import styled from "styled-components";
import {VouchersGamesListTitleMrGreenBox} from "./voucher-games-list-title.mrgreen.box";

export const VouchersGamesListTitleMrGreenCisBox = styled(VouchersGamesListTitleMrGreenBox)`
    background-color: ${({theme}) => theme.colors.backgroundDark};
`;
